"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YesNoInput = void 0;
const react_1 = __importDefault(require("react"));
const SelectPill_1 = require("../buttons/SelectPill");
const react_i18next_1 = require("react-i18next");
const YesNoInput = ({ onItemClick }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement("div", { className: "flex flex-row items-start" },
        react_1.default.createElement("div", { className: "flex flex-col" },
            react_1.default.createElement("div", { className: "flex flex-row flex-wrap mb-2 mr-2" },
                react_1.default.createElement(SelectPill_1.SelectPill, { textContent: t("Yes"), onClick: () => onItemClick(t("Yes")), uniqueChoice: true }),
                react_1.default.createElement(SelectPill_1.SelectPill, { textContent: t("No"), onClick: () => onItemClick(t("No")), uniqueChoice: true })))));
};
exports.YesNoInput = YesNoInput;
//# sourceMappingURL=YesNoInput.js.map